module.exports = __webpack_public_path__ + "static/media/star6.b78f9cac.svg";